import type SubjectAddress from '@Domain/Subjects/SubjectAddress';

class FetchSubjectMembers {
	constructor(
		public readonly facilityId: number,
		public readonly subject: SubjectAddress,
	) {
		Object.freeze(this);
	}
}

export default FetchSubjectMembers;
